import React, { useState } from 'react';
import axios from 'axios';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validate email
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post('http://127.0.0.1:5000/api/newsletter/subscribe', {
        email: email.trim(),
      });

      if (response.status === 200 || response.status === 201) {
        setSuccess(true);
        setEmail('');
        // Reset success message after 5 seconds
        setTimeout(() => {
          setSuccess(false);
        }, 5000);
      }
    } catch (err) {
      console.error('Error subscribing to newsletter:', err);
      const errorMessage = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.message || 
                          'Failed to subscribe. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex w-full justify-center px-[20px] md:px-[40px] py-[36px] md:py-[50px]'>
        <div className='w-full border border-[#5F5CF0]  max-w-[800px] rounded-[24px] md:rounded-[48px] px-[18px] py-[36px] md:py-[80px] md:px-[55px]'>
        <div className='flex flex-col md:items-center'>
            <h4 className='text-[#5F5CF0] text-[24px] leading-[34px] md:text-[48px] font-extrabold md:leading-[52px] mb-[25px] text-left md:text-center font-cabinet'>Receive expert advice<br/> directly to your email</h4>
            <p className='text-[16px] leading-[20px] text-[#757272] md:text-center max-w-[500px] font-satoshi font-bold'>By subscribing to our newsletter, you get updates from <span className='text-[#5F5CF0] font-bold'>Moreproperties </span> and you are accepting our Privacy Policy</p>
        </div>
        <div className='mt-[40px] flex justify-center'>
            <form className='w-full max-w-[485px]' onSubmit={handleSubmit}>
                <div className='flex flex-col space-y-[16px] md:space-y-[0px] md:flex-row md:space-x-[15px]'>
                    <input 
                        type="email" 
                        placeholder='Enter your email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                        className={`border rounded-[12px] px-[16px] py-[14.5px] w-full text-[14px] leading-[0px] max-h-[48px] ${
                          error ? 'border-red-500' : 'border-[#757272]'
                        } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    />
                    <button 
                        type="submit"
                        disabled={loading}
                        className={`rounded-[8px] bg-[#5F5CF0] text-white text-[14px] font-medium px-[33px] py-[15px] max-h-[48px] transition-colors ${
                          loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#4d4bd6]'
                        }`}
                    >
                        {loading ? 'Subscribing...' : 'Subscribe'}
                    </button>
                </div>
                
                {/* Error Message */}
                {error && (
                  <div className='mt-3 text-red-600 text-sm font-satoshi'>
                    {error}
                  </div>
                )}

                {/* Success Message */}
                {success && (
                  <div className='mt-3 text-green-600 text-sm font-satoshi font-bold'>
                    Successfully subscribed! Thank you for joining our newsletter.
                  </div>
                )}
            </form>
        </div>
    </div>
    </div>
    
  )
}
